import Amplify from 'aws-amplify'
import { AUTH_LOGIN_MODE, LS_LOGIN_MODE } from './constant'

export const configureAmplify = () => {
  let loginMode = Number(sessionStorage.getItem(AUTH_LOGIN_MODE))
  if (loginMode === LS_LOGIN_MODE.QR) {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  } else if (loginMode === LS_LOGIN_MODE.OTP) {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_OTP_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_OTP_IDENTITY_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_OTP_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_OTP_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  } else if (loginMode === LS_LOGIN_MODE.EMAIL) {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_EMAIL_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_EMAIL_IDENTITY_POOL_ID,
        userPoolWebClientId:
          process.env.REACT_APP_EMAIL_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_EMAIL_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  } else if (loginMode === LS_LOGIN_MODE.ACTIVE_DIRECTORY) {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        userPoolId: process.env.REACT_APP_ACTIVE_DIRECTORY_USER_POOL_ID,
        identityPoolId: process.env.REACT_APP_ACTIVE_DIRECTORY_IDENTITY_POOL_ID,
        userPoolWebClientId:
          process.env.REACT_APP_ACTIVE_DIRECTORY_WEB_NO_SECRETE_CLIENT_ID,
        region: process.env.REACT_APP_EMAIL_AWS_REGION,
      },
      Analytics: {
        disabled: true,
      },
    })
  }
}
